module.exports = __webpack_public_path__ + "media/new-message.6139d92a.ogg";